// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","BlogPostMenu__item--admin":"hw_a","BlogPostMenu__item--moderator":"hw_b"};